import { Theme } from '@material-ui/core/styles';
import { CSSProperties } from 'react';
import { purple } from 'globals/colors';

interface GetTableRowStyle {
  isSubCategory?: boolean;
  isSomethingToShow: boolean;
  isOpen: boolean;
  theme: Theme;
}

export const getTableRowStyle = ({
  isSubCategory,
  isSomethingToShow,
  isOpen,
  theme: { spacing },
}: GetTableRowStyle): CSSProperties => ({
  backgroundColor: !isSubCategory && isOpen ? purple.V5 : undefined,
  paddingLeft: isSubCategory ? spacing(2) : undefined,
  cursor: isSomethingToShow ? 'pointer' : undefined,
});

export const getIconButtonStyle = ({ spacing }: Theme): CSSProperties => ({
  marginRight: spacing(1),
});

export const getCategoryIconStyle = ({ spacing }: Theme): CSSProperties => ({
  marginRight: spacing(2),
});
